import * as React from 'react';
import { connect } from 'react-redux';
import { fetchDashboardTotalizadores, setFiltroDashboard } from '../../../../actions/dashboardActions';
import { limpiarFiltros } from '../../../../actions/generalActios';
import { filtroUnDia } from '../../../../utilities/fechasFiltro';
const fechaFiltro = filtroUnDia();


class FiltroDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fechaDesde: this.props.filtro != "" ? this.props.filtro.fechaDesde : fechaFiltro.hasta,
      verMes: this.props.filtro.verMes != undefined ? this.props.filtro.verMes : false
    }
  }

  onFilter = (event) => {
    event.preventDefault();

    let idSeller = this.props.idSeller;

    if (this.props.userType.isCategory || this.props.userType.isAdminMod) {
      idSeller = null;
    }

    let params = {
      verMes: this.state.verMes,
      fechaDesde: this.state.fechaDesde,
      tipoUser: this.props.tipoUsuario,
      idSeller: idSeller
    }

    this.props.chargeFilterOptions(params);

    this.props.limpiarFiltros({ 
      publicaciones: true, 
      ordenes: true, 
      sellers: true, 
      showFiltro: false, 
      showFiltroOrdenes: false,
      dashboard: false
    })

    this.props.fetchDashboardTotalizadores(params);
  }

  onClearFilter = (event) => {
    event.preventDefault();

    let params = {
      idSeller: this.props.userType.isCategory || this.props.userType.isAdminMod ? null : this.props.idSeller,
      tipoUser: this.props.tipoUsuario,
      fechaDesde: fechaFiltro.hasta,
      verMes: false
    };

    this.props.fetchDashboardTotalizadores(params);
    this.props.chargeFilterOptions(params);
    this.clearInputs();
  }

  clearInputs = () => {
    this.setState({
      fechaDesde: fechaFiltro.hasta,
      verMes: false
    })
  }

  handleChange = (event) => {

    if (event.target.name === "fechaDesde") {
      this.setState({ fechaDesde: event.target.value })
    }
    if (event.target.name === "verMes") {
      this.setState({ verMes: event.target.checked })
    }
  }


  render() {

    return (
      <div className="card card-body filter-card">
        <form className="row form-material justify-content-around align-items-center"
              onSubmit={this.onFilter}
              onReset={this.onClearFilter}
        >

          <div 
            className="col-12 col-sm-7 col-md-4"
            name="fechaDesde" 
            onMouseEnter={this.handleChange}
          >
            <label className="label-oscura">Fecha desde</label>
            <input 
              type="date" 
              name="fechaDesde" 
              className="form-control" 
              onChange={this.handleChange} 
              value={this.state.fechaDesde} 
            />
          </div>

          <div className="col-12 col-sm-5 col-md-3">
            <label className="label-oscura">Ver Mes</label>
            <input 
              type="checkbox" 
              name="verMes" 
              className="verMes mt-2 ms-4" 
              onChange={this.handleChange} 
              checked={this.state.verMes || false} 
            />
          </div>

          <div className="col-12 col-md-4">
            <div className="row p-1 justify-content-center">
              <button type='submit' className="btn d-inline btn-sm background-rojo-megatone col-auto mx-3" disabled={this.props.isLoading}>Buscar</button>
              <button type='reset' className="btn btn-sm btn-grey d-inline col-auto">Limpiar</button>
              </div>
          </div>
        </form>
    </div>
    )
  }
}


const mapStateToProps = state => ({
  isLoading: state.dashboard.isLoading,
  idSeller: state.general.idSeller,
  userType: state.general.userType
});

export default connect(mapStateToProps, { 
  fetchDashboardTotalizadores, 
  setFiltroDashboard, 
  limpiarFiltros
}) (FiltroDashboard)